import { memo } from 'react';
import { View, StyleSheet, Text } from 'react-native';
import { TextUtils } from '../../components';
import { THEME, COLOR, FONT, __WEB__ } from '../../../constants/styles';
import moment from 'moment';

import {
  EVENT_TYPE_IMMUNIZATION,
  EVENT_TYPE_LAB,
  EVENT_TYPE_PHA,
  EVENT_TYPE_PHA_FLY,
  EVENT_TYPE_AUDIOGRAM,
  EVENT_TYPE_DRHA,
  EVENT_TYPE_READINESS,
  EVENT_TYPE_OHE,
  EVENT_TYPE_SHPE,
  EVENT_TYPE_SERE_ECAC,
  EVENT_TYPE_AUDIOGRAM_SPIROMETRY,
  EVENT_TYPE_SPIROMETRY,
  EVENT_TYPE_SECURITY_FORCES_PCM,
  EVENT_TYPE_DENTAL,
  EVENT_TYPE_CMR,
  EVENT_TYPE_CMR_FLY,
  EVENT_TYPE_IMAGING_IMPORT_PICKUP,
  EVENT_TYPE_ANAM_TEST,
  EVENT_TYPE_COMMUNITY_HEALTH_INTERVIEW,
  EVENT_TYPE_TRAVEL_MEDICINE,
  EVENT_TYPE_SPECIALTY_HEARING,
} from '../../../constants/eventTypes';

const ICON_AUDIOGRAM = require('../../../../resources/appt_types/icon-audiograms.png');
const ICON_DENTAL = require('../../../../resources/appt_types/icon-dental.png');
const ICON_DRHA = require('../../../../resources/appt_types/icon-drha.png');
const ICON_OHE = require('../../../../resources/appt_types/icon-ohe.png');
const ICON_PHA = require('../../../../resources/appt_types/icon-non-fly-pha-cmr.png');
const ICON_PHA_FLY = require('../../../../resources/appt_types/icon-fly-pha-cmr.png');
const ICON_SHPE = require('../../../../resources/appt_types/icon-shpe.png');
const ICON_SERE_ECAC = require('../../../../resources/appt_types/icon-sere-2.png');
const ICON_SPIROMETRY = require('../../../../resources/appt_types/icon-spirometry.png');
const ICON_AUDIOGRAM_SPIROMETRY = require('../../../../resources/appt_types/icon-spirometry.png');
const ICON_LAB = require('../../../../resources/appt_types/icon-lab.png');
const ICON_SECURITY_FORCES_PCM = require('../../../../resources/appt_types/icon-security-forces.png');
const ICON_READINESS = require('../../../../resources/appt_types/icon-readiness.png');
const ICON_IMMUNIZATION = require('../../../../resources/appt_types/icon-immunizations.png');
const ICON_IMAGING = require('../../../../resources/appt_types/icon-imaging.png');
const ICON_ANAM_TEST = require('../../../../resources/appt_types/icon-anam-test.png');
const ICON_COMMUNITY_HEALTH_INTERVIEW = require('../../../../resources/appt_types/icon-community-health.png');
const ICON_TRAVEL_MEDICINE = require('../../../../resources/appt_types/icon-travel-medicine.png');
const ICON_SPECIALTY_HEARING = require('../../../../resources/appt_types/icon-specialty-hearing.png');

function timeLabelForTime(time) {
  return !time || time === '00:00' ? 'All Day' : time;
}

function appointmentLabelForType(eventType) {
  if (eventType === EVENT_TYPE_READINESS) return 'Readiness';
  if (eventType === EVENT_TYPE_CMR) return 'CMR';
  if (eventType === EVENT_TYPE_CMR_FLY) return 'CMR Fly';
  return eventType?.replace(' Appointment', '');
}

const ICON_FOR_EVENT_TYPE = {
  [EVENT_TYPE_CMR]: ICON_PHA,
  [EVENT_TYPE_CMR_FLY]: ICON_PHA_FLY,
  [EVENT_TYPE_IMMUNIZATION]: ICON_IMMUNIZATION,
  [EVENT_TYPE_DRHA]: ICON_DRHA,
  [EVENT_TYPE_OHE]: ICON_OHE,
  [EVENT_TYPE_AUDIOGRAM]: ICON_AUDIOGRAM,
  [EVENT_TYPE_PHA]: ICON_PHA,
  [EVENT_TYPE_PHA_FLY]: ICON_PHA_FLY,
  [EVENT_TYPE_SHPE]: ICON_SHPE,
  [EVENT_TYPE_SERE_ECAC]: ICON_SERE_ECAC,
  [EVENT_TYPE_SPIROMETRY]: ICON_SPIROMETRY,
  [EVENT_TYPE_AUDIOGRAM_SPIROMETRY]: ICON_AUDIOGRAM_SPIROMETRY,
  [EVENT_TYPE_LAB]: ICON_LAB,
  [EVENT_TYPE_SECURITY_FORCES_PCM]: ICON_SECURITY_FORCES_PCM,
  [EVENT_TYPE_DENTAL]: ICON_DENTAL,
  [EVENT_TYPE_READINESS]: ICON_READINESS,
  [EVENT_TYPE_IMAGING_IMPORT_PICKUP]: ICON_IMAGING,
  [EVENT_TYPE_ANAM_TEST]: ICON_ANAM_TEST,
  [EVENT_TYPE_COMMUNITY_HEALTH_INTERVIEW]: ICON_COMMUNITY_HEALTH_INTERVIEW,
  [EVENT_TYPE_TRAVEL_MEDICINE]: ICON_TRAVEL_MEDICINE,
  [EVENT_TYPE_SPECIALTY_HEARING]: ICON_SPECIALTY_HEARING,
};

function iconForType(eventType) {
  return ICON_FOR_EVENT_TYPE[eventType];
}

function AppointmentSelectedTimeSlot(props) {
  if (props.range?.length) {
    const selectedDateLabel =
      moment(props.range[0]).format('MMMM DD, YYYY') +
      ' - ' +
      moment(props.range[props.range.length - 1]).format('MMMM DD, YYYY');

    return (
      <View style={styles.container}>
        <View style={[THEME.basicRow, { justifyContent: 'center' }]}>
          <View style={{ marginRight: 30 }}>
            <Text style={THEME.textBold} numberOfLines={2} ellipsizeMode="tail">
              {appointmentLabelForType(props.eventType)}
            </Text>
            <Text>{selectedDateLabel}</Text>
          </View>
          <View style={{}}>
            <Text style={[styles.time, props.time.length > 20 ? styles.timeSmall : null]}>
              {timeLabelForTime(props.time)}
            </Text>
            <Text style={styles.loc}>{props.location}</Text>
          </View>
        </View>
      </View>
    );
  }
  return (
    <View style={styles.container}>
      <View style={[THEME.basicRow, { flex: 1 }]}>
        <View style={[{ flex: 1, alignItems: 'center' }]}>
          <Text style={[THEME.textBold, { textAlign: 'center' }]} numberOfLines={3}>
            {appointmentLabelForType(props.eventType)}{' '}
          </Text>
        </View>
        <View style={[styles.miniCal]}>
          <View style={styles.miniCalTop}>
            <Text style={styles.dateStr}>
              {TextUtils.ac(moment(props.date).format('MMM YYYY'))}
            </Text>
          </View>
          <View style={styles.miniCalBottom}>
            <Text style={styles.dateNum}>{moment(props.date).format('DD')}</Text>
          </View>
        </View>
        <View style={[{ flex: 1, alignItems: 'center' }]}>
          {props.eventType !== EVENT_TYPE_READINESS && (
            <>
              <Text style={[styles.time, props.time?.length > 20 ? styles.timeSmall : null]}>
                {timeLabelForTime(props.time)}
              </Text>
              <Text style={styles.loc}>{props.location}</Text>
            </>
          )}
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  miniCal: {
    borderRadius: 10,
    width: 110,
    height: 92,
    marginLeft: 13,
    shadowOpacity: 0.1,
    shadowRadius: 4,
    shadowColor: COLOR.shadow,
    shadowOffset: { height: 2, width: 0 },
    elevation: 2,
  },
  miniCalTop: {
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10,
    borderWidth: 1,
    borderBottomWidth: 0,
    borderColor: COLOR.emphasis,
    backgroundColor: COLOR.emphasis,
    flex: 0.45,
    justifyContent: 'center',
    alignItems: 'center',
  },
  miniCalBottom: {
    borderBottomRightRadius: 10,
    borderBottomLeftRadius: 10,
    borderWidth: 1,
    borderTopWidth: 0,
    borderColor: '#ddd',
    flex: 0.55,
    justifyContent: 'center',
    alignItems: 'center',
  },
  dateStr: {
    ...FONT.semibold,
    textAlign: 'center',
    fontSize: 16,
  },
  dateNum: {
    ...FONT.medium,
    textAlign: 'center',
    fontSize: 28,
  },
  textWrapper: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  time: {
    ...FONT.semibold,
    fontSize: 22,
    maxWidth: 150,
    color: COLOR.text,
  },
  timeSmall: {
    fontSize: 16,
  },
  loc: {
    ...FONT.regular,
    fontSize: 14,
    color: COLOR.text,
  },
});

module.exports = {
  AppointmentSelectedTimeSlot: memo(AppointmentSelectedTimeSlot),
  appointmentLabelForType,
  iconForType,
};
